<div class="grid align-items-end vertical-container fluid ">
  <div class="col-6">
    <h5>В новом документе ({{moveAction}}) </h5>
    <div class="card flex justify-content-left gap-3 field-checkbox">
      <div *ngFor="let action of actions" class="flex align-items-center">
        <p-checkbox [(ngModel)]="selectedActions"
                    [label]="action.name"
                    name="actionGroup"
                    [value]="action.value"
                    [disabled]="action.disabled"
                    (onChange)="onChangeActions($event)" />
      </div>
    </div>
    <!--<p-selectButton [options]="actions" [(ngModel)]="selectedActions" multiple="true" optionLabel="name" optionValue="value" (onChange)="onDocTypeChanges($event)"></p-selectButton>-->
  </div>
  <div class="col-2">
    <p-button label="Очистить" icon="pi pi-trash" (onClick)="onClearRows($event)" styleClass="mt-2 mr-4" [disabled]="false"
              pTooltip="Очистить содержимое нового документа" tooltipPosition="top"></p-button>
  </div>
  <div class="col-2">
    <p-button label="Сначала" icon="pi pi-undo" (onClick)="onRefreshRows($event)" styleClass="mt-2 mr-4" [disabled]="false"
              pTooltip="Обновить содержимое нового документа" tooltipPosition="top"></p-button>
  </div>

  <div class="col-2">
    <p-button label="Подобрать" icon="pi pi-eye" (onClick)="onStartProduction($event)" styleClass="mt-2 p-button-help" [disabled]="false"
              pTooltip="Обновить содержимое нового документа" tooltipPosition="top"></p-button>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-tabView (onChange)="onMoveActionChange($event)">

        <p-tabPanel header="Переместить недостающее" [selected]="moveAction==1" rightIcon="pi pi-bookmark">
          <app-new-document-dlg-process-tran-imp [newDocument]="newDocument"
                                                 [newDocuments]="newDocuments"
                                                 [parentDocument]="parentDocument"
                                                 [docItems]="docItems"
                                                 [command]="command"
                                                 [selectedActions]="selectedActions"
                                                 (onCreateNewDocuments)="onCreateNewDocumentsEvent($event)"
                                                 *ngIf="moveAction==1">
          </app-new-document-dlg-process-tran-imp>
        </p-tabPanel>

        <p-tabPanel header="Подобрать в производство" [selected]="moveAction==2" rightIcon="pi pi-bookmark" [disabled]="!thereIsManufacturedItems">
          <app-new-document-dlg-process-tran-prod [newDocument]="newDocument"
                                                  [newDocuments]="newDocuments"
                                                  [parentDocument]="parentDocument"
                                                  [docItems]="docItems"
                                                  [command]="command"
                                                  [selectedActions]="selectedActions"
                                                  (onCreateNewDocuments)="onCreateNewDocumentsEvent($event)"
                                                  (onGetTransactionResult)="getTransactionResult($event)"
                                                  *ngIf="moveAction==2">
          </app-new-document-dlg-process-tran-prod>
        </p-tabPanel>

        <p-tabPanel header="Переместить внутри" [selected]="moveAction==4" rightIcon="pi pi-bookmark" [disabled]="!eligibleForMove">
          <app-new-document-dlg-process-tran-sale [newDocument]="newDocument"
                                                  [newDocuments]="newDocuments"
                                                  [parentDocument]="parentDocument"
                                                  [docItems]="docItems"
                                                  [command]="command"
                                                  [selectedActions]="selectedActions"
                                                  (onCreateNewDocuments)="onCreateNewDocumentsEvent($event)"
                                                  *ngIf="moveAction==4">
          </app-new-document-dlg-process-tran-sale>
          <!--<div class="grid fluid" *ngIf="moveAction==4">

      <div class="col-6 xl:col-6 sm:col-12">
        <app-companyselector labelKey="Переместить на юрлицо" [parentCompany]="parentDocument.DOCMANCLIID" (selectedCompanyID)="lcoCompanySelected($event)"></app-companyselector>
      </div>
      <div class="col-6 xl:col-6 sm:col-12">
        <app-departmentselector labelKey="Переместить на склад" [parentCompany]="parentDocument.DOCLCOCLIID" [selectedID]="newDocument.DOCLCODEPID" (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
      </div>
    </div>-->
        </p-tabPanel>

        <p-tabPanel header="Произвольно" [selected]="moveAction==3" rightIcon="pi pi-bookmark">
          <app-new-document-dlg-process-tran-move [newDocument]="newDocument"
                                                  [newDocuments]="newDocuments"
                                                  [parentDocument]="parentDocument"
                                                  [docItems]="docItems"
                                                  [command]="command"
                                                  [selectedActions]="selectedActions"
                                                  (onCreateNewDocuments)="onCreateNewDocumentsEvent($event)"
                                                  *ngIf="moveAction==3">
          </app-new-document-dlg-process-tran-move>
        </p-tabPanel>

        <p-tabPanel header="Между юрлицами" [selected]="moveAction==5" rightIcon="pi pi-bookmark">
          <app-new-document-dlg-process-tran-inter></app-new-document-dlg-process-tran-inter>
          <!--<app-new-document-dlg-process-tran-move [newDocument]="newDocument"
                                                  [newDocuments]="newDocuments"
                                                  [parentDocument]="parentDocument"
                                                  [docItems]="docItems"
                                                  [command]="command"
                                                  [selectedActions]="selectedActions"
                                                  (onCreateNewDocuments)="onCreateNewDocumentsEvent($event)" *ngIf="moveAction==5">
          </app-new-document-dlg-process-tran-move>-->
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
